// Weer op het bord (0026; docs/DESIGN.md §8.WE.5): alleen de losse woorden die de kiosk zelf toont
// (woord bij de weerchip, labels onder de pictogrammen, "niet bekend", de strook). De zinnen maakt
// de server (weatherPrayer.*.ts, niet in de kioskbundel). Zelfde woorden als in weatherPrayer
// (weatherPrayer.test.ts bewaakt dat). Nooit het woord gebed.
export const kioskWeatherNl = {
    title: 'Weer',
    /** Schermlezer op de weerchip. */
    open: 'Weer: {feel}. Tik voor meer.',
    stale: 'Weer even niet bekend',
    today: 'Vandaag',
    tomorrow: 'Morgen',
    close: 'Sluiten',
    feel: { cold: 'koud', chilly: 'fris', mild: 'lekker', warm: 'warm', hot: 'heet' },
    itemLabels: {
        thick_coat: 'Dikke jas',
        coat: 'Jas',
        sweater: 'Vest of trui',
        raincoat: 'Regenjas',
        boots: 'Laarzen',
        hat_gloves: 'Muts en handschoenen',
        umbrella: 'Paraplu',
        sunscreen: 'Smeren',
        sun_hat: 'Pet op',
        water_bottle: 'Drinkfles',
        shorts: 'Korte broek',
    },
    /** Golf 6b: weerdetail op het bord (tik op de weerchip of de strook). Kindertaal, rustig. */
    day: {
        today: 'Zo wordt het vandaag',
        tomorrow: 'Zo wordt het morgen',
        temp: 'Hoe warm?',
        tempValue: '{min} tot {max} graden',
        feels: 'Het voelt {feel}',
        rain: 'Regen',
        rainWords: {
            dry: 'Het blijft droog',
            small: 'Misschien een klein buitje',
            likely: 'Er kan regen komen',
            wet: 'Het gaat regenen',
        },
        rainWhen: 'Van {from} tot {until}',
        wind: 'Wind',
        windWords: {
            calm: 'Bijna geen wind',
            light: 'Een beetje wind',
            fresh: 'Flinke wind',
            strong: 'Harde wind',
            very_strong: 'Heel harde wind',
        },
        windForce: 'Windkracht {bft}',
        sun: 'Zon',
        sunrise: 'Op om {time}',
        sunset: 'Onder om {time}',
        uvWords: {
            moderate: 'De zon is sterk. Lang buiten? Dan smeren.',
            high: 'De zon is heel sterk. Smeren en pet op.',
        },
        course: 'Hoe gaat de dag?',
        back: 'Terug',
        now: 'Nu',
    },
};
//# sourceMappingURL=kioskWeather.nl.js.map